import React from 'react'

const BtnMediumTick = ({ color = 'white' }: { color?: string }) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.3334 4L6.00008 11.3333L2.66675 8"
                stroke={color}
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    )
}

export default BtnMediumTick
